// a24-search-normalization.js
/**
 * Zentrale, pflegeleichte Suchnormalisierung für Außenborder24.
 *
 * Shopify Search & Discovery bleibt die bevorzugte Stelle für Merchandising-
 * Synonyme. Diese Datei ist für Schreibweisen, Tippfehler und technische
 * Fälle gedacht, die direkt vor der nativen Shopify-Suche bereinigt werden.
 */
(function () {
  'use strict';

  /*
   * Dictionary: komplette Suchanfrage links, normalisierte Anfrage rechts.
   * Neue Begriffe können hier ergänzt werden, ohne neue Funktionen zu bauen.
   */
  const dictionary = {
    '__a24_test_normalization__': 'a24 test normalization'
  };

  /*
   * Begriffsliste: einzelne Wörter oder Phrasen in einer Suchanfrage ersetzen.
   * Beispiel:
   * { terms: ['aussenborder', 'ausenborder'], replacement: 'Außenborder' }
   */
  const termReplacements = [];

  /*
   * Optionaler Hook für Sonderfälle. Für normale Begriffe bitte dictionary
   * oder termReplacements nutzen.
   */
  const rules = [];

  function normalizeWhitespace(value) {
    return String(value || '').trim().replace(/\s+/g, ' ');
  }

  function escapeRegExp(value) {
    return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function comparable(value) {
    return normalizeWhitespace(value)
      .toLocaleLowerCase('de-DE')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '');
  }

  function readReplacement(entry) {
    return normalizeWhitespace(entry?.replacement || entry?.to || entry?.output || '');
  }

  function readTerms(entry) {
    if (!entry) return [];
    if (Array.isArray(entry.terms)) return entry.terms;
    return [entry.term, entry.from, entry.match].filter(Boolean);
  }

  function applyDictionary(query) {
    const queryKey = comparable(query);
    const match = Object.entries(dictionary).find(([source]) => comparable(source) === queryKey);
    return match ? normalizeWhitespace(match[1]) : query;
  }

  function replaceWholePhrase(query, phrase, replacement) {
    const normalizedPhrase = normalizeWhitespace(phrase);
    const normalizedReplacement = normalizeWhitespace(replacement);
    if (!normalizedPhrase || !normalizedReplacement) return query;

    const matcher = new RegExp(`(^|\\s)${escapeRegExp(normalizedPhrase)}(?=\\s|$)`, 'giu');
    return normalizeWhitespace(query.replace(matcher, `$1${normalizedReplacement}`));
  }

  function applyTermReplacements(query) {
    return termReplacements.reduce((current, entry) => {
      const replacement = readReplacement(entry);
      if (!replacement) return current;

      return readTerms(entry).reduce((next, term) => replaceWholePhrase(next, term, replacement), current);
    }, query);
  }

  function applyRules(query) {
    return rules.reduce((current, rule) => {
      if (!rule || typeof rule.matches !== 'function' || typeof rule.transform !== 'function') return current;
      return rule.matches(current) ? normalizeWhitespace(rule.transform(current)) : current;
    }, query);
  }

  function normalize(query) {
    let result = normalizeWhitespace(query);
    result = applyDictionary(result);
    result = applyTermReplacements(result);
    result = applyRules(result);
    return normalizeWhitespace(result);
  }

  window.A24SearchNormalization = {
    normalize,
    comparable,
    dictionary,
    termReplacements,
    rules
  };
}());
